/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compliance_Link_Subject_ToInputs */

const tr_pricing_compliance_link_subject_to = /** @type {(inputs: Pricing_Compliance_Link_Subject_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`koşullarına tabidir.`)
};

const en_pricing_compliance_link_subject_to = /** @type {(inputs: Pricing_Compliance_Link_Subject_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is subject to the terms of`)
};

const de_pricing_compliance_link_subject_to = /** @type {(inputs: Pricing_Compliance_Link_Subject_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unterliegt den Bedingungen von`)
};

const ru_pricing_compliance_link_subject_to = /** @type {(inputs: Pricing_Compliance_Link_Subject_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`регулируется условиями`)
};

/**
* | output |
* | --- |
* | "is subject to the terms of" |
*
* @param {Pricing_Compliance_Link_Subject_ToInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compliance_link_subject_to = /** @type {((inputs?: Pricing_Compliance_Link_Subject_ToInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compliance_Link_Subject_ToInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_compliance_link_subject_to(inputs)
	if (locale === "de") return de_pricing_compliance_link_subject_to(inputs)
	if (locale === "ru") return ru_pricing_compliance_link_subject_to(inputs)
	return tr_pricing_compliance_link_subject_to(inputs)
});